import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import { closeDialog } from '../../../store/modules/dialog';
import Button from '../../common/Button';

const Wapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: flex-end;
  align-items: center;
`;

export default function ActiveLinkDialogFooter({ onSubmit }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const onClickCancel = () => {
    dispatch(closeDialog());
  };

  return (
    <Wapper>
      <Button
        cssExt={css`
          font-size: 13px;
          font-weight: 700;
          background: #1d7ff9;
          border-radius: 2px;
          color: #fff;
          border: none;
          width: 81px;
          height: 30px;
          margin-right: 12px;
          &:hover {
            background: #0b8793;
            opacity: 0.4;
            cursor: pointer;
          }
        `}
        onClick={onSubmit}>
        {t('Common.Insert')}
      </Button>
      <Button
        cssExt={css`
          font-size: 13px;
          border-radius: 2px;
          color: #2f3133;
          border: 1px solid #b1b6bb;
          width: 81px;
          height: 30px;
        `}
        onClick={onClickCancel}>
        {t('Common.Cancel')}
      </Button>
    </Wapper>
  );
}
